import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const OnboardingLayoutContentNarrow = ({ className, children }) => {
  const classes = classNames({
    [className]: !!className,
    'onboarding-layout-content-narrow': true,
  });

  return <div className={classes}>{children}</div>;
};

OnboardingLayoutContentNarrow.propTypes = propTypes;

export default OnboardingLayoutContentNarrow;
